// extracted by mini-css-extract-plugin
module.exports = {"textTable":"MGXioaPkYbdINQH0GDWXEw==","totalTitle":"ClA2bpRE+c-6GF-WxK132Q==","numCol":"_5UkNGRWKMt3XmnYUTtYZYg==","normalCol":"Xw9mU515lS8YsS0AB9q4yw=="};